import { render, staticRenderFns } from "./NominationPreview.vue?vue&type=template&id=9867dc1e"
import script from "./NominationPreview.vue?vue&type=script&lang=js"
export * from "./NominationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports